module.exports = __webpack_public_path__ + "img/delete.35e9a5d7.svg";